import { AnyAction, combineReducers } from '@reduxjs/toolkit'
import { reducer as formReducer } from 'redux-form/immutable'
import storage from 'redux-persist/lib/storage'

import alerts from './alertReducer'
import apiMeta from './apiPersist/apiMetaSlice'
import app from './appSlice'
import auth from './authReducer'
import { baseApi, persistedApiReducer } from './baseApi'
import healthPlan from './healthPlanReducer'
import informedConsentBanner from './informedConsentBannerSlice'
import persistScopedReducer from './persistScope/persistScopedReducer'
import privacyGuard from './privacyGuardSlice'
import user from './userSettingsSlice'
import calendar from '../calendar/data/calendarSlice'
import clients from '../clients/data/clientsReducer'
import downloadCSV from '../common/components/downloadCSV/data/downloadReducer'
import { LOGOUT } from '../common/constants/reduxConstants'
import lyraTherapy from '../lyraTherapy/data/lyraTherapyReducer'
import myInfo from '../myInfo/data/myInfoReducer'
import paymentHistory from '../paymentHistory/data/paymentHistoryReducer'
import payments from '../payments/data/paymentsReducer'
import practices from '../practices/data/practicesReducer'
import providers from '../providers/data/providersReducer'
import reconciler from '../reconciler/data/reconcilerReducer'
import requestPayment from '../requestPayment/data/requestPaymentReducer'
import scheduling from '../scheduling/data/schedulingReducer'

const persistedUserSettingsReducer = persistScopedReducer(
  {
    key: 'userSettings',
    storage: storage,
  },
  user,
)

const appReducer = combineReducers({
  form: formReducer,
  auth,
  practices,
  payments,
  downloadCSV,
  providers,
  myInfo,
  clients,
  alerts,
  requestPayment,
  paymentHistory,
  reconciler,
  lyraTherapy,
  healthPlan,
  privacyGuard,
  informedConsentBanner,
  scheduling,
  calendar,
  userSettings: persistedUserSettingsReducer,
  [baseApi.reducerPath]: persistedApiReducer,
  apiMeta,
  app,
})

type StoreState = ReturnType<typeof appReducer>
const rootReducer: typeof appReducer = (state: ReturnType<typeof appReducer>, action: AnyAction) => {
  if (action.type === LOGOUT) {
    return appReducer(
      {
        userSettings: {
          _scopes: { ...state.userSettings._scopes },
          _persist: (state.userSettings as any)._persist,
        } as unknown as StoreState['userSettings'],
        api: {
          _scopes: { ...state.api._scopes },
          _persist: (state.api as any)._persist,
        } as unknown as StoreState['api'],
      } as StoreState,
      action,
    )
  }
  return appReducer(state, action)
}
export default rootReducer
